import { ShieldCheck, FlaskConical, AlertTriangle, ClipboardList } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const Compliance = () => {
  const { t } = useLanguage();
  const c = t.compliance;
  return (
    <section id="compliance" className="py-24 bg-[#F2E8D5]/70 border-t-2 border-brand-green/10" data-testid="compliance-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14 space-y-3">
          <span className="text-xs font-bold uppercase tracking-widest text-brand-orange">{c.label}</span>
          <h2 className="font-display text-4xl sm:text-5xl uppercase text-brand-green">{c.title}</h2>
          <p className="text-base text-brand-green/75">{c.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-brand-cream border border-brand-green/10 rounded-3xl p-7 space-y-4" data-testid="compliance-directions">
            <div className="w-11 h-11 rounded-2xl bg-brand-bone text-brand-orange flex items-center justify-center border border-brand-green/10">
              <ClipboardList className="w-5 h-5" />
            </div>
            <h3 className="font-display text-xl uppercase text-brand-green">{c.directionsTitle}</h3>
            <ol className="space-y-2 text-xs text-brand-green/80 leading-relaxed list-decimal list-inside">
              {c.directions.map((d) => <li key={d}>{d}</li>)}
            </ol>
          </div>

          <div className="bg-brand-cream border border-brand-green/10 rounded-3xl p-7 space-y-4" data-testid="compliance-ingredients">
            <div className="w-11 h-11 rounded-2xl bg-brand-bone text-brand-green flex items-center justify-center border border-brand-green/10">
              <FlaskConical className="w-5 h-5" />
            </div>
            <h3 className="font-display text-xl uppercase text-brand-green">{c.ingredientsTitle}</h3>
            <p className="text-xs text-brand-green/80 leading-relaxed">{c.ingredients}</p>
          </div>

          <div className="bg-brand-green text-white rounded-3xl p-7 space-y-4" data-testid="compliance-warnings">
            <div className="w-11 h-11 rounded-2xl bg-white/10 text-brand-citrus flex items-center justify-center border border-white/15">
              <AlertTriangle className="w-5 h-5" />
            </div>
            <h3 className="font-display text-xl uppercase">{c.warningsTitle}</h3>
            <ul className="space-y-2 text-xs text-white/85 leading-relaxed">
              {c.warnings.map((w) => <li key={w} className="font-semibold">{w}</li>)}
            </ul>
          </div>

          <div className="bg-brand-cream border border-brand-green/10 rounded-3xl p-7 space-y-4" data-testid="compliance-precautions">
            <div className="w-11 h-11 rounded-2xl bg-brand-bone text-brand-orange flex items-center justify-center border border-brand-green/10">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <h3 className="font-display text-xl uppercase text-brand-green">{c.precautionsTitle}</h3>
            <ul className="space-y-2 text-[11px] text-brand-green/80 leading-relaxed">
              {c.precautions.map((p) => <li key={p}>{p}</li>)}
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
};
